export default __webpack_public_path__ + "static/media/arikentApiary.941c460b.jpeg";